import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Events} from "ionic-angular";
import 'rxjs/add/operator/map';

import {GetNewsService} from "./get-news-service";

@Injectable()
export class NewsService {
  public news: Object[]; // {newsId: XX, newsContent: {}} check su newsContent // controllo facoltativo usando il prefetchsize
  private perPage: number = 50;

  private totalNews: number;
  private newPointer: number;
  private oldPointer: number;

  private watcher;
  private authLostSent = false;
  private url;
  private uac;
  private ext;
  private agencies = [];
  seenNews = [];

  constructor(
    public http: Http,
    private getNewsService: GetNewsService,
    public events: Events
  ) {
    this.news = [];
    this.totalNews = 0;
    this.newPointer = 0;
    this.oldPointer = 0;
  }

  // First run!

  // controllo se c'è la finestra 1


  // creo la finestra uno

  reset() {
    this.authLostSent = false;
    this.news = [];
    this.totalNews = 0;
    this.newPointer = 0;
    this.oldPointer = 0;
    if (typeof this.watcher !== 'undefined') {
      clearInterval(this.watcher);
    }
  }

  startNewsServer() {
    this.getNewsService.windowsStatus().subscribe(
      (data) => {
        if (data.status == 1 && data.ws) {
          if (data.ws.length >= 2) {
            this.totalNews = data.ws[1].newsCount;
            if (this.totalNews != this.newPointer) {
              // avviso che ci sono news
              // this.events.publish('feed:gotnews');
              this.getNewNews();
            }
            this.watcher = setInterval(() => {
              this.getNewsService.windowsStatus().subscribe(
                (data) => {
                  if (data.status == 1 && data.ws) {
                    if (data.ws.length >= 2) {
                      this.totalNews = data.ws[1].newsCount;
                      if (this.totalNews != this.newPointer) {
                        // avviso che ci sono news
                        // this.events.publish('feed:gotnews');
                        this.getNewNews();
                      }
                    }
                  } else {
                    clearInterval(this.watcher);
                    if (!this.authLostSent) {
                      this.authLostSent = true;
                      this.events.publish('authLost');

                    }
                  }
                },
                err => console.log(err)
              )
            }, 4000)
          }
        } else {
          this.events.publish('authLost');
        }
      },
      err => console.log(err)
    );
  }

  /**
   * restituisce un array con le nuove news
   * * logicamente verificato
   */
  getNewNews() {
    let from = 0;

    if (this.newPointer == 0) {
      // è il primo avvio, importo le prime 50 notizie e aggiorno i puntatori
      this.newPointer = this.totalNews;
      if (this.totalNews > 50) {
        this.oldPointer = this.totalNews - this.perPage;
      } else {
        this.oldPointer = 0;
      }
      from = this.oldPointer;
    } else {
      // non è il primo avvio, inserisco le news nell'array
      from = this.newPointer;
      this.newPointer += this.perPage;
      if (this.newPointer > this.totalNews) {
        this.newPointer = this.totalNews;
      }
    }

    this.getNewsService.getNewsReferences(1, from, this.perPage).subscribe(
      (data) => {
        if (data.newsID !== '' && data.newsID != undefined) {
          this.getNewsService.getTitlesList(data.newsID).subscribe(
            (data) => {
              if (data.news) {
                for (let item of data.news.reverse()) {
                  if (item.title != '') {
                    this.news.unshift(item);
                  }
                }
              }
            }
          )
        }
      },
      err => console.log(err)
    );
  }

  /**
   * restituisce un array con le news vecche, in quantità "per page"
   * * logicamente verificato
   */
  public getNextPage(): Promise<void> {
    return new Promise((resolve, reject) => {
      let from;
      let max = this.perPage;

      // non sono presenti altre news da visualizzare
      if (this.oldPointer == 0) {
        resolve();
      }

      if (this.oldPointer < this.perPage) {
        // sono più vicino alla fine delle notizie di quante siano visualizzabili per pagina... sistemo
        from = 0;
        max = this.perPage - this.oldPointer;
        this.oldPointer = 0;
      } else {
        this.oldPointer -= this.perPage;
        from = this.oldPointer;
      }

      this.getNewsService.getNewsReferences(1, from, this.perPage)
        .subscribe((data) => {
          this.getNewsService.getTitlesList(data.newsID)
            .subscribe((data) => {
              for (const item of data.news) {
                this.news.push(item);
              }
              resolve();
            },
            (err) => {
              console.log(err);
              reject();
            });
        },
        (err) => {
          console.log(err);
          reject();
        });
    });
  }

  getNews(id, keywords) {
    this.markAsRead(id);
    return this.getNewsService.getNews(id, keywords);
  }

  markAsRead(id) {
    for (let n of this.news) {
      if (+(n as any).id === +id) {
        (n as any).seen = true;
        break;
      }
    }
  }

  getNewsT(id) {
    return this.getNewsService.getNewsT(id);
  }


  hasMorePages() {
    return this.oldPointer !== 0
  }

  /**
   * avvia una ricerca
   */
  search(searchTerm, searchDate) {
    // 1. chiamata per effettuare la ricerca
    // this.reset();
    return this.getNewsService.search(1, searchDate, searchDate, searchTerm, true);
    //
  }

  /**
   * cambia la data della ricerca
   */
  changeDate(date) {
    // 1. chiamata per impostare la data
    return this.getNewsService.selectDate(1, date);
    // return this.getNewsService.selectDate(99, date);
  }

  selectArchive(menuPage) {
    return this.getNewsService.selectMenu(1, menuPage);
  }

  getAgencyImage(position) {
    if (this.uac[position - 1] === '') {
      return null;
    } else {
      return this.url + this.uac[position - 1] + this.ext;
    }
  }

  initializeLogos() {
    // 1. ottengo gli url
    this.getNewsService.getUrlLogos().subscribe((result) => {
        this.url = result.url;
        this.uac = result.uac;
        this.ext = result.ext;
      },
      err => console.log(err));

    // 2. ottengo l'elenco delle agenzie
    this.getNewsService.getAgencyGlobals().subscribe(
      (result) => {
        for (let agency of result) {
          this.agencies.push(agency.name);
        }

      },
      // err => console.log(err)
    )
  };


  isSeen(id: number) {
    return (this.seenNews.indexOf(id) !== -1)
  }
}



// WEBPACK FOOTER //
// ./src/providers/news-service.ts